import SearchIcon from '@mui/icons-material/Search';
import { useTheme, MenuItem, Autocomplete } from '@mui/material';
import MuiCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~/client/components/base/arranger';
import { CalendarEdit } from '~/client/components/base/icon';
import { spc } from '~/client/components/base/spacer';
import TextField from '~/client/components/base/text-field';

interface Props {
  className?: string;
}

const selectItems = [
  {
    value: 'item1',
    label: 'Item 1',
  },
  {
    value: 'item2',
    label: 'Item 2',
  },
  {
    value: 'item3',
    label: 'Item 3',
  },
];

const TextFields: React.FC<Props> = ({ className }) => {
  const theme = useTheme();

  return (
    <div className={className}>
      <MuiCard variant="outlined">
        <CardContent>
          <Arranger direction="column" className="v2-content">
            <TextField id="default-with-label" label="Label" />
            <TextField
              id="helper-text"
              label="Input with helper text"
              helperText="Helper text"
            />
            <TextField
              id="outlined-error"
              label="Input wtih error"
              helperText="Helper text for error"
              error
            />
            <TextField
              id="disabled-with-helper"
              label="Disabled"
              disabled
              helperText="Helper text"
            />
            <TextField id="multilined" label="Multiline" multiline />
            <TextField
              id="outlined-select"
              label="Select"
              select
              defaultValue="item1"
            >
              {selectItems.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="outlined-end-adornment"
              label="With end adornment"
              endAdornment={<CalendarEdit />}
            />
            <Autocomplete
              id="outlined-search"
              freeSolo
              options={selectItems.map((option) => option.label)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search"
                  search
                  startAdornment={<SearchIcon />}
                />
              )}
            />
          </Arranger>
        </CardContent>
      </MuiCard>
    </div>
  );
};

export default muiStyled(TextFields)(
  ({ theme }) => css`
    display: flex;

    .v2-content {
      /* Add spacings after all text fields */
      > div {
        margin-bottom: ${theme.spacing(spc.xs)};
      }
    }
  `
);
